import { Requester } from './Requester';

export const EnrollOrg = async (orgId: string): Promise<boolean> => {
    console.log('path: ', `organizations/${orgId}/enroll`);
    try {
        const response = await Requester<any>({
            path: `organizations/${orgId}/enroll`,
            method: 'POST'
        });

        return response;
    } catch (e) {
        console.error('Enroll org request failed');
        return Promise.reject(e);
    }
};
